"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = require("../ServiceRequest");
var applyConversationActionJsonRequest_1 = require("../factory/applyConversationActionJsonRequest");
function applyConversationActionOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = applyConversationActionJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("ApplyConversationAction", req, options);
}
exports.default = applyConversationActionOperation;
